export default "__VITE_ASSET__a182fba0__"